export default __webpack_public_path__ + "static/media/dispatch_later_color.2d9a033d.svg";